export default __webpack_public_path__ + "static/media/donut-chart-left.7a71fb35.svg";